export const URL_LOGIN = "/api/v1/signin";
export const URL_REGISTER = "/api/v1/register";
export const URL_CONFIRM_EMAIL = "/api/v1/confirm-email";
export const URL_FORGOT_PASSWORD = "/api/v1/forgot-password";
export const URL_RE_SEND_EMAIL = "/api/v1/re-send-email";
export const URL_RESET = "/api/v1/reset-password";

export const URL_MODEL = "/api/v1/resource/models";
export const URL_GENRES = "/api/v1/resource/genres";
export const URL_ADDRESS_LATLNG = "/api/v1/resource/url";
export const URL_SUNAT_DNI = "/api/v1/resource/dni";
export const URL_SUNAT_RUC = "/api/v1/resource/ruc";

export const URL_DRIVER = "/api/v1/driver";
export const URL_CLIENT = "/api/v1/client";
export const URL_EMPLOYEE = "/api/v1/employee";
export const URL_TRAVELLER = "/api/v1/traveller";
export const URL_VEHICLE = "/api/v1/vehicle";

export const URL_SUB_ROLE = "/api/v1/subrole";
export const URL_ADDRESS = "/api/v1/address";
export const URL_BOOKING_BUSINESS = "/api/v1/booking-business";
export const URL_REPORT_BOOKING = "/api/v1/report";

export const URL_ENTERPRISE = "/api/v1/enterprise";

export const URL_INVOICE = "/api/v1/invoice";
